import startCase from "lodash/startCase";

/**
 * Prettifies a string to be used as element name or page name in events.
 *
 * @param input - String to prettify
 * @returns Prettified string
 */
const prettifyString = (input: string): string => {
  return startCase(
    input.replaceAll("/", " ").trim().replaceAll("-", " ").toLowerCase()
  );
};

export { prettifyString };
